import { Link } from 'react-router-dom';
import './Navigation.css';

/**
 * Unified back button component with consistent styling.
 *
 * @param {Object} props
 * @param {string} props.to - Route path to navigate to
 * @param {string} props.label - Button text (without arrow)
 * @param {Object} [props.state] - Navigation state to pass
 * @param {string} [props.className] - Additional CSS classes
 */
function BackButton({ to, label, state, className = '' }) {
  return (
    <Link
      to={to}
      state={state}
      className={`nav-back-btn ${className}`.trim()}
    >
      {label}
    </Link>
  );
}

export default BackButton;
